<template>
  <div>
    <van-swipe :show-indicators="false" @change="onChange" :loop="false">
      <van-swipe-item v-for="(item, index) in list" :key="index" @click="showDetail()">
        <div class="header-box">
          <div class="title-box">
            <div class="name">{{ item.sxjhmc }} ></div>
            <div class="icon-box" :style="{ backgroundColor: getIconColor(item.status) }">
              <img v-if="item.status == '2' || item.status == '4'" src="../../../../../assets/images/sx_icon_1.png" alt="" />
              <img v-else src="../../../../../assets/images/sx_icon_2.png" alt="" />
              <!-- <img src="" alt="" /> -->
              <div>{{ item.status == '1' ? '未开始' : item.status == '2' ? '免实习' : item.status == '3' ? '实习中' :'已结束' }}</div>
            </div>
          </div>
          <img class="banner" src="../../../../../assets/images/sx_banner.png" alt="" />
          <van-grid :border="false" :column-num="4">
            <van-grid-item v-for="(child, index) in item.infolist" :key="'total' + index">
              <div class="total-item">
                <div class="data">{{ child.value }}</div>
                <div class="name">{{ child.title }}</div>
              </div>
            </van-grid-item>
          </van-grid>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      index: 0
    }
  },
  computed: {
    getIconColor() {
      return status => {
        let colorList = ['#999999','#15BB83', '#0189F9' , '#15BB83' ]
        return colorList[parseInt(status) - 1]
      }
    },
  },
  methods:{
    onChange(index) {
      this.index = index
      this.$emit('change', index)
      this.$store.dispatch('setSxjhid', this.list[index].sxjhid)
      this.$store.dispatch('setIsty', this.list[index].isty)
      this.$store.dispatch('setTimeRange', [this.list[index].sxkssj, this.list[index].sxjssj])
    },
    showDetail(){
      this.$store.dispatch('setSxjhid', this.list[this.index].sxjhid)
      this.$store.dispatch('setIsty', this.list[this.index].isty)
      this.$store.dispatch('setTimeRange', [this.list[this.index].sxkssj, this.list[this.index].sxjssj])
      this.$router.push({
        path: '/internship/plan'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.header-box {
  width: 345px;
  height: 196px;
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  margin: 0 auto 10px;
  position: relative;
  overflow: hidden;
  .title-box {
    position: absolute;
    top: 30px;
    left: 20px;
    .name {
      width: 153px;
      height: 48px;
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
    }
    .icon-box {
      display: flex;
      min-width: 66px;
      height: 24px;
      width: 71px;
      background: #0189f9;
      border-radius: 12px;
      align-items: center;
      padding-left: 5px;
      // padding-right: 10px;
      img {
        width: 14px;
        height: 14px;
        margin-right: 5px;
      }
      div {
        font-size: 14px;
        color: #ffffff;
      }
    }
  }
  .banner {
    width: 100%;
    height: 120px;
    display: block;
  }
  .total-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .name {
      font-weight: 400;
      font-size: 12px;
      color: #757575;
      text-align: center;
    }
    .data {
      font-weight: 600;
      font-size: 18px;
      color: #666666;
      text-align: center;
      margin-bottom: 6px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/components/swiperHeader.vue